import { Box, Typography } from '@mui/material';

import { useFeature } from '@growthbook/growthbook-react';
import { UserAvatarMenu } from './modules/UserAvatarMenu';
import { HeaderItems } from './HeaderItems';

import { withShowable } from '../../../_global/lib/withShowable';
import LanguageSelector from './modules/LanguageSelector';
import { Show } from '../../../../components/Show';
import { FEATURE_FLAG_KEYS } from '../../../../config/growthbook';
import { REDACTED_FIELD } from '../../../../config/logrocket';

interface Props {
  account: any;
}

const CowbellMainHeader = ({ account }: Props) => {
  const languageSelectorFeature = useFeature(
    FEATURE_FLAG_KEYS.LANGUAGE_SELECTOR
  );

  return (
    <HeaderItems>
      <Box className={REDACTED_FIELD}>
        <Typography className="tertia-text">{account.name}</Typography>
      </Box>

      <Box>
        <UserAvatarMenu />
      </Box>

      <Show when={languageSelectorFeature.on}>
        <Box>
          <LanguageSelector />
        </Box>
      </Show>
    </HeaderItems>
  );
};

export default withShowable(CowbellMainHeader);
